import { useMemo } from 'react'
import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'

const DettagliProdottoListinoConfezionamento = ({ prezzi }) => {
  const t = useTrans()

  const isGratuito = (item) => {
    return item?.prezzi_confezionamento?.[0]?.prezzo == 0
  }

  const confezionamenti = useMemo(() => {
    const allPersonalizzazioni = prezzi.tecniche.flatMap((tecnica) =>
      tecnica.posizioni.flatMap((posizione) =>
        posizione.numero_colori.flatMap((numeroColore) => numeroColore.personalizzazioni_objects)
      )
    )

    // per ogni confezionamento mi salvo la prima personalizzazione
    const uniqueConfezionamentoMap = allPersonalizzazioni.reduce((accumulator, currentObject) => {
      const confezionamentoId = currentObject.confezionamento.id
      if (!accumulator[confezionamentoId]) {
        accumulator[confezionamentoId] = currentObject
      }
      return accumulator
    }, {})

    const uniqueObjects = Object.values(uniqueConfezionamentoMap)

    return uniqueObjects
  }, [prezzi])

  console.log('prezziPersonalizzazioni', prezzi, 'confezionamenti', confezionamenti)
  return (
    <div className="dettagli-prodotto__listino">
      {confezionamenti?.map((item, i) => (
        <div className="dettagli-prodotto__listino__block" key={i}>
          {isGratuito(item) ? (
            <div className="dettagli-prodotto__disclaimer" key={`chunk-${i}`}>
              *{item.confezionamento.nome} ({t('Senza costi aggiuntivi')})
            </div>
          ) : (
            <>
              <p className="dettagli-prodotto__listino__block-title">{item.confezionamento.nome}</p>
              <div className="dettagli-prodotto__listino__table" key={`chunk-${i}`}>
                <div className="dettagli-prodotto__listino__col">
                  <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                    {t('A partire da')}
                  </p>
                  <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                    {t('Prezzo')}
                  </p>
                </div>

                {item.prezzi_confezionamento.map((obj, j) => {
                  return (
                    <div key={j} className="dettagli-prodotto__listino__col">
                      <div className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity">
                        {obj.a_partire_da}
                      </div>
                      <div className="dettagli-prodotto__listino__cell">
                        {priceNotation(obj.prezzo, 3)} €
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  )
}

export default DettagliProdottoListinoConfezionamento
